import styled, { css } from 'styled-components';

export const Content = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s2};
  `,
);

export const ButtonsWrapper = styled.div(
  ({ theme }) => css`
    display: inline-flex;
    min-width: ${theme.sz.s44};
    gap: ${theme.sz.s3};
    margin-top: ${theme.sz.s4};

    @media (max-width: ${theme.sz.ms}) {
      flex-direction: column;
      justify-content: center;
    }
  `,
);
